import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Button } from '../components/Button';

export function Confirmation() {
  const navigate = useNavigate();
  const [goal, setGoal] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!goal.trim()) return;

    try {
      setIsSubmitting(true);
      setError('');

      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('User not logged in');

      const userId = session.user.id;

      await supabase.from('previous_goals').insert({
        user_id: userId,
        text: goal.trim(),
        status: 'active',
        use_count: 1,
        last_used_at: new Date().toISOString()
      });

      navigate('/impactintentions');
    } catch (err: any) {
      console.error('Error saving goal:', err);
      setError(err.message || 'Something went wrong');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg p-8 space-y-6 text-center">
        <h1 className="text-4xl font-bold text-[#004060]">🎉 Welcome to Freelie!</h1>

        <p className="text-xl text-gray-700">
          Prepare to discover a simple system that will elevate your health, wealth, and relationships. To get started we need to ask a few questions.
        </p>

        <p className="text-lg font-medium text-gray-800 mt-6">First, what is your biggest goal currently?</p>
    <label htmlFor="goal" className="block text-lg font-medium text-gray-700">
        </label>
        <input
          id="goal"
          type="text"
          value={goal}
          onChange={(e) => setGoal(e.target.value)}
          className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#236caf]"
          placeholder="Write your current goal here"
        />

        {error && <p className="text-red-600 text-sm">{error}</p>}

        <Button onClick={handleSubmit} disabled={isSubmitting || !goal.trim()} className="w-full mt-4">
          {isSubmitting ? 'Starting...' : 'Next Are Your Core Values'}
        </Button>
      </div>
    </div>
  );
}
